import { render, staticRenderFns } from "./YouTubeWidget.vue?vue&type=template&id=0fc703e8&scoped=true"
import script from "./YouTubeWidget.vue?vue&type=script&lang=js"
export * from "./YouTubeWidget.vue?vue&type=script&lang=js"
import style0 from "./YouTubeWidget.vue?vue&type=style&index=0&id=0fc703e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc703e8",
  null
  
)

export default component.exports